export default class Continguts {

	constructor(continguts, futurs) {
		this.continguts_originals = continguts;
		this.futurs = futurs;

		this.continguts = [];
		this.afegeix_continguts();
		this.seleccionats = new Map();
	}

	afegeix_continguts() {
		let nous_continguts = [...this.continguts_originals];

		const rng = new Math.seedrandom(this.futurs.x * 10000 + this.futurs.y * 1000)
		nous_continguts.sort(() => rng() - rng())

		const continguts_repetits = [...this.continguts];
		continguts_repetits.sort(() => rng() - rng())

		// Eliminem dels nous els que encara queden dels antics i els tornem a afegir al final
		nous_continguts = nous_continguts.filter(item => ! continguts_repetits.includes(item))
		nous_continguts.push(...continguts_repetits)

		this.continguts.push(...nous_continguts); // Afegim els nous continguts al final de l'array
	}

	get(i, j, num, i_principal, j_principal) {

		// Si ja els hem seleccionat amb anterioritat
		const group_id = this.getGroupId(i, j);
		if (this.seleccionats.has(group_id)) {
			return [...this.seleccionats.get(group_id)]
		}

		if (num > this.continguts.length) {
			this.afegeix_continguts();
		}

		// Si és el del centre els eliminem dels possibles i els marquem com a seleccionats
		if ((i === i_principal) && (j === j_principal)) {
			const selected_continguts = this.continguts.splice(0, num)
			this.set(i, j, selected_continguts);
			return [...selected_continguts];
		}

		// Sinó agafem els num primers
		return this.continguts.slice(0, num);
	}
	getGroupId(i, j) {
		return "i" + i + "j" + j;
	}

	set(i, j, selected_continguts) {
		this.seleccionats.set(this.getGroupId(i, j), selected_continguts);
	}

}
